export const environment = {
  production: false,
  server: {
    "derechos": "https://sschoperadoras.anh.gov.co/back/derechos/derechos/",
    "sso": "https://sschoperadoras.anh.gov.co/back/",
    "dynamic": "/back/",
    "clave":"https://sschoperadoras.anh.gov.co/back/"
  },
  context: {
    "derechos":"dynamics_querys_de",
    "ssch":"dynamics_querys_v2"
  }

};
